import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard2 from './Dashboard2';

function Product3Router() {
  useEffect(() => {
    // console.log("Product2Router mounted");

    return () => {
      // console.log("Product2Router unmounted");
    };
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/product2/dashboard" replace />} />
      <Route path="/dashboard" element={<Dashboard2 />} />
      <Route path="*" element={<Navigate to="/product2/dashboard" replace />} />
    </Routes>
  );
}

export default Product3Router;
